// extracted by mini-css-extract-plugin
export default {"products":"tw-z","card":"uw-z","oosMessaging":"vw-z"};